module.exports = __webpack_public_path__ + "img/206.31536c99.jpg";